import React from "react";
import { LEARN_MORE_URL, SUPPORT_URL } from "../../../constants";

const DecisionPending = () => {

  return (
    <>
      <p className="font-bold text-gray-600 text-2xl my-4 pb-2">THANK YOU</p>
      <div className="stepDescriptionText" style={{ padding: "0 0 30px 0" }}>
        Approval Pending
      </div>
      <div className="innerStack">
        <div className="textContainer" style={{ maxWidth: 300, paddingTop: 12 }}>
          We are reviewing your application and will get back to you shortly through email.
        </div>
        <a href={LEARN_MORE_URL}>
          <input
            type="button"
            name="button"
            value="Learn More"
            className="continueButton cursor-pointer"
          />
        </a>
        <div className="textContainer pt-4">
          <span>Have any questions? </span>
          <a className="text-green-primary" href={SUPPORT_URL}>
            Contact Us
          </a>
        </div>
      </div>
    </>
  );
};

export default DecisionPending;
